import { render, staticRenderFns } from "./mainticketmodal.vue?vue&type=template&id=d8cb24e6"
import script from "./mainticketmodal.vue?vue&type=script&lang=js"
export * from "./mainticketmodal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports